export default __webpack_public_path__ + "2023b33084ad1a78dbd2ab5e71f28354.png";